import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import { Button } from '@mui/material'
import IconButton from '@mui/material/IconButton'
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined'
import CloseIcon from '@mui/icons-material/Close'
import { Box } from '@mui/system'
import UseTranslation from '../../hooks/UseTranslation'

const FilterView = ({ filter, setFilter, hideIcon }) => {
  const { t } = UseTranslation()
  const handleClick = () => {
    setFilter(!filter)
  }

  return (
    <Box onClick={handleClick} sx={styles.filterView}>
      {!hideIcon && (
        <IconButton aria-label="filter" sx={styles.filterButton}>
          {filter ? <CloseIcon sx={styles.filterIcon} /> : <FilterAltOutlinedIcon />}
        </IconButton>
      )}
      <Box style={styles.formControl}>
        <Button
          id="sortBy-button"
          sx={styles.sortButton}
          aria-haspopup="true"
          endIcon={<ArrowDropDownIcon />}>
          {t?.['Filter By']}
        </Button>
      </Box>
    </Box>
  )
}

const styles = {
  filterView: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    float: 'right',
    cursor: 'pointer',
    '& .MuiInputLabel-root': {
      fontSize: 18,
      paddingLeft: 10,
    },
    '& .MuiSvgIcon-root ': {
      width: { xs: '12px', sm: '16px' },
      height: { xs: '12px', sm: '16px' },
    },
  },
  filterButton: {
    borderRadius: '15px',
    border: 'solid 1px #e9edf0',
    boxShadow: '0 2px 7px 0 rgba(0, 0, 0, 0.04)',
    marginLeft: 'auto',
  },
  filterIcon: { color: 'primary.main' },
  formControl: {
    marginLeft: 8,
    marginTop: -7,
    '& .MuiSelect-select': {
      paddingTop: 0,
      paddingBottom: 0,
      '&:focus': {
        borderRadius: 0,
        backgroundColor: 'transparent',
      },
    },
    '& .MuiInput-underline:before,& .MuiInput-underline:after': {
      display: 'none',
    },
  },
  sortButton: {
    cursor: 'pointer',
    backgroundColor: 'transparent',
    border: 'none',
    padding: 0,
    fontSize: { xs: 14, sm: 18 },
    color: '#44444f',
    display: 'flex',
    alignItems: 'center',
    lineHeight: { xs: 1, sm: 1.4 },
    marginTop: 1,
    textTransform: 'capitalize',
  },
}

export default FilterView
